import moment from "moment";
import { tableResponse } from "./constants";

export class Search {
  public column_one: string | number;
  public column_two: string | number;
  public column_three: string | number;
  public column_four: string | number;
  public column_five: number | string;
  public column_six: string | number;
  public type: string;
  public id: string;
  public data: any;
  constructor(item: any, tableObj: any) {
    const source: any = item;
    this.column_one = "";
    this.column_two = "";
    this.column_three = "";
    this.column_four = "";
    this.column_five = "";
    this.column_six = "";
    this.type = tableObj.key;
    this.id = "";
    this.data = source;
    if (this.type === tableResponse.Assets || this.type === tableResponse.Resources) {
      this.column_one = source.host_name;
      this.column_two = source.vendor;
      this.column_three = source.category;
      this.column_four = source.region;
      this.column_five = source.is_decommissioned
        ? "Decommissioned"
        : !isNaN(source.rating)
          ? parseFloat(source.rating).toFixed(2)
          : source.rating;
      this.column_six = !isNaN(source.failed_count)
        ? "Misconfigurations: " + source.failed_count
        : "Severity: " + source.failed_count;
      if (!isNaN(source.failed_count)) {
        this.column_six = !isNaN(source.failed_count)
          ? "Misconfigurations: " + source.failed_count
          : "";
      }
      this.id = source.id_device || source.id || source.device_id || "";
    } else if (this.type === tableResponse.Scans) {
      this.column_one = source.name;
      this.column_two = source.date_added
        ? moment(source.date_added).format("YYYY-MM-DD HH:mm:ss")
        : source.date_added;
      this.column_three = source.user_email;
      this.column_four = source.device_count;
      this.column_five = parseFloat(source.rating).toFixed(2);
      this.column_six = !isNaN(source.vulnerabilities)
        ? "Misconfigurations: " + source.vulnerabilities
        : "Severity: " + source.vulnerabilities;
      if (source.status === "5") {
        this.column_five = "Cancelled";
      }
      if (source.status === "4") {
        this.column_five = "Failed";
      }
      this.id = source.id;
    } else if (this.type === tableResponse.Benchmarks) {
      this.column_one = source.name;
      this.id = source.id;
    } else if (this.type === tableResponse.Parameters || this.type === tableResponse.CloudControls) {
      this.column_one = source.name;
      // The API returns a misspelled "bechmark" field containing an array
      // of control standards (e.g. ["NIST","CIS","PCI DSS"]). Prefer that
      // and join with commas for a clean display. Fall back to other fields
      // if necessary.
      if (Array.isArray(source.bechmark) && source.bechmark.length > 0) {
        this.column_two = source.bechmark.map((t: string) => t?.trim()).join(", ");
      } else if (Array.isArray(source.tags) && source.tags.length > 0) {
        this.column_two = source.tags.map((t: string) => t?.trim()).join(", ");
      } else if (source.bechmark && typeof source.bechmark === "string") {
        // If the backend returned a concatenated string, normalize common commas
        this.column_two = source.bechmark.replace(/\s*,\s*/g, ", ");
      } else if (source.tags && typeof source.tags === "string") {
        this.column_two = source.tags.replace(/\s*,\s*/g, ", ");
      } else if (source.benchmark && Array.isArray(source.benchmark)) {
        this.column_two = source.benchmark.map((t: string) => t?.trim()).join(", ");
      } else {
        this.column_two = source.benchmark || source.bechmark || "";
      }

      this.column_three = "Severity: " + source.severity;
      this.column_four = source.description;
      this.id = source.id;
      this.column_six = "";
    } else if (this.type === tableResponse.Roles) {
      this.column_one = source.name;
      this.column_two =
        source.default_role === "True" ? "Pre-Defined Role" : "Custom Role";
      this.id = source.id;
    } else if (this.type === tableResponse.Users) {
      this.column_one = source.email;
      this.column_two = source.firstname + " " + source.lastname;
      this.column_three = source.role_name;
      this.id = source.id;
    } else if (this.type === tableResponse.CVE) {
      this.column_one = source.id;
      this.column_two = source.asset_count;

      this.column_three = "Severity: " + source.severity;

      this.column_four = "Epss: " + source.epss + "%";
      this.column_five = source.score;
      this.column_six = source.cisas_key;
      this.id = source.id;
    }
  }
}
